var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.code)?_c('Markdown',{staticClass:"mt-4",attrs:{"title":_vm.code.title,"content":_vm.code.md}}):_c('S404')
}
var staticRenderFns = []

export { render, staticRenderFns }